const state = {
  viewType: localStorage.getItem('viewType') || 'user', // 'user' ou 'group'
};

const getters = {
  viewType: state => state.viewType
};

const mutations = {
  SET_VIEW_TYPE(state, type) {
    state.viewType = type;
    localStorage.setItem('viewType', type);
  }
};

const actions = {
  setViewType({ commit }, type) {
    commit('SET_VIEW_TYPE', type);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};